export const SHOULD_TRACE_NETWORK_REQUESTS = "should_trace_network_requests";

export function getShouldAddTracingHeaderToRequests(): boolean {
  return window.localStorage.getItem(SHOULD_TRACE_NETWORK_REQUESTS) === "true";
}
